import { render, staticRenderFns } from "./invoices-custom-group.renderer.vue?vue&type=template&id=3dfbaf52&scoped=true&"
import script from "./invoices-custom-group.renderer.vue?vue&type=script&lang=js&"
export * from "./invoices-custom-group.renderer.vue?vue&type=script&lang=js&"
import style0 from "./invoices-custom-group.renderer.vue?vue&type=style&index=0&id=3dfbaf52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfbaf52",
  null
  
)

export default component.exports